import React, { useState, useRef, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

interface DatePickerModalProps {
    date: string | null;
    onDateChange: (newDate: string) => void;
}

const parseDate = (dateStr: string): Date => {
    // Если дата в формате "YYYY-MM-DD", парсим как локальное время
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
    return new Date(dateStr);
};

const DatePickerModal: React.FC<DatePickerModalProps> = ({ date, onDateChange }) => {
    const [open, setOpen] = useState(false);

    const [selectedDate, setSelectedDate] = useState<Date | null>(date ? parseDate(date) : new Date());
    const datePickerRef = useRef<HTMLDivElement>(null);

    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
        if (date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            onDateChange(`${year}-${month}-${day}`);
        }
        setOpen(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (datePickerRef.current && !datePickerRef.current.contains(event.target as Node)) {
            setOpen(false);
        }
    };

    const formatDate = (date: string): string => {
        const dateObj = parseDate(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // месяцы начинаются с 0
        const year = dateObj.getFullYear();
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (date) {
            setSelectedDate(parseDate(date));
        }
    }, [date]);

    useEffect(() => {
        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <span>{date ? formatDate(date) : '----'}</span>
            <Icon name="calendar" style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => setOpen(!open)} />
            {open && (
                <div ref={datePickerRef} style={{ position: 'absolute', zIndex: 1000 }}>
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        inline
                    />
                </div>
            )}
        </div>
    );
};

export default DatePickerModal;
